module.exports = __webpack_public_path__ + "static/border-8f1790c438141725f6a779304aab8395.png";